import { FColorTypes } from "@fantaskticedtechlimited/fui-colorlib";
import { style } from "typestyle";

export const sideNavbar = style({
    background: "white !important",
    border: "1px solid "+FColorTypes.PRIMARY_GREY,
    boxShadow: "none",
    boxSizing: "border-box"
})
